import axios from "axios";
import { Notification, MessageBox, Message } from "element-ui";
import store from "@/store";
import { getToken } from "@/utils/auth";
import errorCode from "@/utils/errorCode";
import router from "@/router";

axios.defaults.headers["Content-Type"] = "application/json;charset=utf-8";
// 创建axios实例
const service = axios.create({
  // axios中请求配置有baseURL选项，表示请求URL公共部分
  baseURL: process.env.VUE_APP_BASE_API,
  // 跨域请求时不发送Cookie
  withCredentials: false,
  // 超时
  timeout: 10000,
});
// request拦截器
service.interceptors.request.use(
  (config) => {
    // 是否需要设置 token
    const isToken = (config.headers || {}).isToken === false;
    if (getToken() && !isToken) {
      config.headers["Authorization"] = getToken(); // 让每个请求携带自定义token 请根据实际情况自行修改
    }
    // get请求映射params参数
    if (config.method === "get" && config.params) {
      let url = config.url + "?";
      for (const propName of Object.keys(config.params)) {
        const value = config.params[propName];
        var part = encodeURIComponent(propName) + "=";
        if (value !== null && typeof value !== "undefined") {
          if (typeof value === "object") {
            for (const key of Object.keys(value)) {
              const params = propName + "[" + key + "]";
              var subPart = encodeURIComponent(params) + "=";
              url += subPart + encodeURIComponent(value[key]) + "&";
            }
          } else {
            url += part + encodeURIComponent(value) + "&";
          }
        }
      }
      url = url.slice(0, -1);
      config.params = {};
      config.url = url;
    }
    return config;
  },
  (error) => {
    console.warn(error);
    Promise.reject(error);
  }
);

let isRedirecting = false;

// 响应拦截器
service.interceptors.response.use(
  (res) => {
    console.log("response", res);

    // 文件流下载
    if (res.config.responseType === "blob") {
      // 报错了
      if (res.data.type === "application/json") {
        return new Promise((resolve, reject) => {
          res.data.text().then((text) => {
            const data = JSON.parse(text);

            console.log(data);

            const code = data.code || 200;
            const msg = errorCode[code] || data.msg || errorCode["default"];
            Message({
              message: msg,
              showClose: true,
              type: "error",
            });
            reject(new Error(msg));
          });
        });
      } else {
        // 尝试去取文件名
        let fileName = "";
        if (
          typeof res.headers["content-disposition"] === "string" &&
          res.headers["content-disposition"].includes("filename=")
        ) {
          console.log();
          fileName = res.headers["content-disposition"]
            .split(";")[1]
            .split("=")[1];
        }
        console.log("fileName", fileName);
        return {
          filename: fileName,
          blob: res.data,
        };
      }
    }

    // 未设置状态码则默认成功状态
    const code = res.data.code || 200;
    // 获取错误信息
    const msg = errorCode[code] || res.data.msg || errorCode["default"];
    if (code === 401) {
      // 避免重复显示提示
      if (res.config.url === "/logout") return;
      store.dispatch("LogOut");

      if (isRedirecting) return Promise.reject();
      isRedirecting = true;
      MessageBox.confirm(
        "登录状态已过期，您可以继续留在该页面，或者重新登录",
        "系统提示",
        {
          confirmButtonText: "重新登录",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          router.push({ path: "/login" });
          setTimeout(() => {
            isRedirecting = false;
          }, 1000);
        })
        .catch(() => {
          isRedirecting = false;
        });
      return Promise.reject();
    } else if (code === 500) {
      // 非静默模式报错
      if (!res.config["silentMode"]) {
        Message({
          message: msg,
          showClose: true,
          type: "error",
        });
      }
      return Promise.reject(new Error(msg));
    } else if (code !== 200) {
      Notification.error({
        title: msg,
      });
      return Promise.reject("error");
    } else {
      return res.data;
    }
  },
  (error) => {
    console.warn("err" + error);
    let { message } = error;
    if (message === "Network Error") {
      message = "后端接口连接异常";
    } else if (message.includes("timeout")) {
      message = "系统接口请求超时";
    } else if (message.includes("Request failed with status code")) {
      message = "系统接口" + message.substr(message.length - 3) + "异常";
    }
    Message({
      message: message,
      showClose: true,
      type: "error",
      duration: 5 * 1000,
    });
    return Promise.reject(error);
  }
);

export default service;
